import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../WithRouterHOC';
import { message } from 'antd';
import HTTP from '../../../script/service';
import jxCaptchaVerifiedHOC from '../../../components/jxCaptchaVerifiedHOC';
import './RiskCaptchaContent.scss';

const RiskCaptchaContent = (props) => {
  const {
    initCaptchaVerified,
    resetCaptchaVerified,
    getCaptchaVerified,
    destroyCaptchaVerified,
    visible,
    onCancel,
    onSuccess,
    base,
  } = props;
  const { riskAuthData } = base;

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (!!visible) {
      initCaptcha();
    } else {
      destroyCaptchaVerified();
    }
  }, [visible]);

  const initCaptcha = () => {
    initCaptchaVerified(
      { isGlobal: true, bizType: 1, geeType: 0 },
      () => {
        captchaSuccess();
      },
      () => {
        onCancel && onCancel();
      }
    );
  };

  // 完成校验
  const captchaSuccess = () => {
    const geeValidate = getCaptchaVerified();
    if (riskAuthData?.sceneType) geeValidate.sceneType = riskAuthData.sceneType;
    HTTP._post_risk_validate({ ...geeValidate })
      .then(async (res) => {
        if (res?.code === 200) {
          onSuccess && onSuccess();
        } else {
          resetCaptchaVerified();
          message.error(res?.message ?? '验证失败,请稍后重试');
          initCaptcha();
        }
      })
      .catch((e) => {
        message.error(e?.message ?? '验证失败,请稍后重试');
      });
  };

  return <></>;
};

export default connect((store) => ({ base: store }))(
  withRouter(jxCaptchaVerifiedHOC(RiskCaptchaContent), { withRef: true })
);
